<template>
    <div class="page_footer flex-col">
        <div class="group_footer flex-col">
            <img
                    class="image_65"
                    referrerpolicy="no-referrer"
                    src="../../assets/footer/chpc_footer_line01.png"
            />
            <div class="address-container flex-row">
                <div class="block_address flex-col">

                    <div class="text-wrapper_138 flex-row justify-between">
                        <div class="city-tab" @click="switchCity('beijing')">
                            <span :class="currentCity === 'beijing' ? 'text_366' : 'text_367'">北京</span>
                            <img
                                    v-show="currentCity === 'beijing'"
                                    class="image_66"
                                    src="../../assets/footer/chpc_footer_line02.png"
                            />
                        </div>
                        <div class="city-tab" @click="switchCity('shanghai')">
                            <span :class="currentCity === 'shanghai' ? 'text_366' : 'text_367'">上海</span>
                            <img
                                    v-show="currentCity === 'shanghai'"
                                    class="image_66"
                                    src="../../assets/footer/chpc_footer_line02.png"
                            />
                        </div>
                    </div>
                    <span class="text_368">电话：{{ cityInfo[currentCity].phone }}</span>
                    <span class="text_369" v-if="cityInfo[currentCity].fax">传真：{{ cityInfo[currentCity].fax }}</span>
                    <div class="text-wrapper_139 flex-row justify-between">
                        <span class="text_370">地址：</span>
                        <span class="paragraph_24">{{ cityInfo[currentCity].address }}</span>
                    </div>
                </div>
            </div>
            <!-- 链接部分 -->
            <div class="links-container">
                <div class="links-section">
                    <div class="links-column">
                        <div class="link-header" @click="handleMenuClick('about')">走进康柏</div>
                        <div class="link-item" @click="handleMenuClick('about#introduce-section2')">关于我们</div>
                        <div class="link-item" @click="handleMenuClick('about#honor-section2')">企业荣誉</div>
                        <div class="link-item" @click="handleMenuClick('about#value-section2')">行业价值</div>
                        <div class="link-item" @click="handleMenuClick('about#server-section2')">服务优势</div>
                    </div>

                    <div class="links-column">
                        <div class="link-header" @click="handleMenuClick('Advisory')">核心业务</div>
                        <div class="link-item" @click="handleMenuClick('Advisory')">渠道风控管理</div>
                        <div class="link-item" @click="handleMenuClick('compliance')">业务合规管理</div>
                        <div class="link-item" @click="handleMenuClick('consultation')">企业健康咨询</div>

                    </div>

                    <div class="links-column">
                        <div class="link-header" @click="handleMenuClick('Information')">新闻中心</div>
                        <div class="link-item" @click="handleMenuClick('dynamics')">康柏动态</div>
                        <div class="link-item" @click="handleMenuClick('observation')">行业观察</div>
                    </div>

                    <div class="links-column">
                        <div class="link-header" @click="handleMenuClick('contact')">联系我们</div>
                        <div class="link-item" @click="handleMenuClick('contact')">联系我们</div>
                        <div class="link-item" @click="handleMenuClick('join')">加入我们</div>
                    </div>
                </div>
            </div>

            <div class="section_zkh flex-row">
                <div class="image-text_277 flex-col justify-between">
                    <img
                            class="image_67"
                            referrerpolicy="no-referrer"
                            src="../../assets/footer/chpc_footer_gzh.png"
                    />
                    <div class="text-group_377 flex-col">
                        <span class="text_380">官⽅微信公众号</span>
                        <span class="text_381">关注康柏汉森</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-wrapper_143 flex-col">
                <span class="text_382">
            版权所有©北京康柏汉森医药科技咨询有限责任公司&nbsp;京ICP备01020304号&nbsp;技术支持：技术支持部
          </span>
        </div>
        <div class="group_contact flex-row">
            <div class="group_contact_content" @click="handleClick()">
                <div class="image-text_group flex-row justify-between">
                    <img
                            class="icon_call"
                            referrerpolicy="no-referrer"
                            src="../../assets/footer/chpc_footer_call.png"
                    />
                    <span class="text-group_call">联系我们</span>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

    export default {
        data() {
            return {
                currentCity: 'beijing',
                cityInfo: {
                    beijing: {
                        phone: '010-58204887',
                        fax: '010-58204839',
                        address: `北京市朝阳区建国路93号院万达广场8号楼2606室
          Room 2606,Block 8,Wanda Plaza,No.93 Jianguo Road,Chaoyang District,Beijing 100022,P.R.China`
                    },
                    shanghai: {
                        phone: '021-63331086',

                        address: `上海市黄浦区蒙自路 757 号平安滨江金融中心 30 层 3001 室
          Suite 3001, 30/F, Ping An Binjiang Financial Center, No. 757 Mengzi Road, Huangpu District, Shanghai 200023, P.R.China`
                    }
                },
                formData: {
                    name: '',
                    company: '',
                    phone: '',
                    email: '',
                    message: ''
                },

                loopData3: [
                    { lanhutext0: '关于我们', lanhutext1: '企业荣誉', },
                    { lanhutext0: '渠道风控管理', lanhutext1: '业务合规管理',href1:'consultation',href2:'consultation' },
                    { lanhutext0: '康柏动态', lanhutext1: '行业观察', specialSlot1: { lanhutext0: '新闻中心' }, slot1: 1 },
                    { lanhutext0: '联系我们', lanhutext1: '加入我们',href1:'contact',href2:'join', specialSlot1: { lanhutext0: '联系我们' }, slot1: 1 }
                ],

            };
        },
        mounted() {

        },
        methods: {
            switchCity(city) {
                this.currentCity = city;
            },
            scrollToAnchor(anchor) {
                const element = document.getElementById(anchor);
                if (element) {
                    // 使用 scrollIntoView 平滑滚动到目标元素
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            // 新增点击处理方法
            handleMenuClick(menuName) {

                this.goto(menuName)
            },
            goto(url){
                url = '/' + url;
                if (url.includes('#')) {
                    let check = url.split('#')[0];
                    if (this.$route.path === check){
                        this.scrollToAnchor(url.split('#')[1]);
                    }else{
                        this.$router.push(url).then(() => {
                            this.scrollToAnchor(url.split('#')[1]);
                        });
                    }

                } else {
                    if (this.$route.path !== url){
                        this.$router.push(`${url}`).then(() => {
                            window.scrollTo(0, 0);
                        });
                    }else{
                        window.scrollTo(0, 0);
                    }
                }
            },
            submitForm() {
                console.log('提交表单数据:', this.formData);

                let data = this.formData;
                let that = this;
                this.$HTTP.addConsult(data).then(resp => {
                    if(resp.code == 200){
                        that.$message.success("信息已提交成功!")
                    }
                });

            },
            handleClick(){
                this.$emit('contactMobile', 1);
            },
        }
    };
</script>

<style scoped lang="css"  >
    body {
        -webkit-text-size-adjust: 100% !important;
        text-size-adjust: 100% !important;
        transform: scale(1) !important;
    }

    /* 阻止微信字体放大 */

    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }


    .city-tab {
        position: relative;  /* 添加相对定位 */
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }

    /* 修改下划线样式 */
    .image_66 {
        position: absolute;
        bottom: -20px;  /* 调整定位到文字下方 */
        left: 50%;
        transform: translateX(-50%);
        width: 32px;
        height: 2px;
        transition: all 0.3s ease;
    }

    /* 调整文字和下划线的整体布局 */
    .text-wrapper_138 {
        position: relative;
        padding-bottom: 15px;  /* 为下划线留出空间 */
    }


    .image_65 {
        max-width: 1200px;
        height: 1px;
    }

    .address-container {
        margin-bottom: 1px;
        background: #F9F9FB;
        box-shadow: inset 0px -2px 0px 0px #E8E8E8;
        width: 100%;
        height: 212px;

        display: flex;
        justify-content: center; /* 新增居中属性 */

    }

    .section_link {
        width: 100%;
        height: 180px;
        display: flex;
        justify-content: center;
    }

    .section_zkh {
        width: 100%;
        height: 160px;

        display: flex;
        justify-content: center;

    }

    .text-wrapper_138 {
        width: 91px;
        height: 23px;
        margin-left: 1px;
    }

    .text_366 {
        width: 33px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(0, 134, 131, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 23px;
    }

    .text_367 {
        width: 33px;
        height: 23px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 16px;
        text-align: right;
        white-space: nowrap;
        line-height: 23px;

        transition: color 0.3s ease;
    }

    .text_368 {
        width: 140px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin: 13px 0 0 1px;
    }

    .text_369 {
        width: 141px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin: 7px 0 0 1px;
    }

    .text-wrapper_139 {
        width: 384px;
        height: 60px;
        margin-top: 7px;
    }

    .text_370 {
        width: 43px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .paragraph_24 {
        width: 354px;
        height: 60px;
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        white-space: pre-line;
    }

    .block_address {
        width: 400px;
        height: 131px;
        margin: 26px 0 0 0;
        padding-left: 10px;
    }

    /* 链接部分容器 */
    .links-container {
        display: flex;
        justify-content: center;
        margin-bottom: 1px;
        margin-top: 20px;
    }

    /* 链接部分 */
    .links-section {
        display: flex;
        max-width: 600px;
        width: 100%;
        justify-content: space-between;
        gap: 10px;
        padding: 0 10px;
    }

    .links-column {
        flex: 1;
        min-width: 100px;
    }

    .link-header {
        font-size: 15px;
        color: #252525;
        font-weight: 500;
        margin-bottom: 15px;
        cursor: pointer;
        transition: color 0.3s;
    }

    .link-header:hover, .link-item:hover {
        color: #008683;
    }

    .link-item {
        font-size: 12px;
        color: #666;
        margin-bottom: 10px;
        cursor: pointer;
        transition: color 0.3s;
    }

    .text-wrapper_140 {
        width: 100%;
        max-width: 520px;
        height: 25px;
        margin-left: 1px;
    }

    .text_371 {
        width: 73px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.09179999679327011px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
    }

    .text_372 {
        width: 73px;
        height: 25px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        letter-spacing: 0.09179999679327011px;
        font-family: AlibabaPuHuiTi_3_65_Medium;
        font-weight: 500;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
        margin-left: 67px;
    }


    .list_30 {
        width: 504px;
        height: 45px;
        margin-top: 11px;
    }

    .text-wrapper_141 {
        position: relative;
        width: 56px;
        height: 45px;
        margin-right: 85px;
    }

    /* 新增hover样式 */
    .text_371:hover,
    .text_372:hover,
    .text_375:hover,
    .text_376:hover,
    .text_379:hover {
        color: #008683 !important;
        cursor: pointer;
        transition: color 0.3s ease;
    }

    .text_375 {
        width: 84px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_376 {
        width: 84px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 5px;
    }

    .text-wrapper_142 {
        width: 225px;
        height: 20px;
        margin-top: 5px;
    }


    .text_379 {
        width: 56px;
        height: 20px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 5px;
    }

    .image-text_277 {
        width: 100px;
        height: 140px;
    }

    .image_67 {
        width: 100px;
        height: 100px;
    }

    .text-group_377 {
        position: relative;
        width: 84px;
        height: 33px;
        margin: 7px 0 0 9px;
    }

    .text_380 {
        width: 84px;
        height: 17px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 12px;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin-top: 16px;
    }

    .text_381 {
        position: absolute;
        left: 6px;
        top: 0;
        width: 72px;
        height: 17px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 12px;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
    }

    .text-wrapper_143 {
        height: 60px;
        background: url(../../assets/footer/chpc_footer_input_03.png) 0px 0px no-repeat;
        margin: -1px 0 1px 0;
        width: 100%;
        background-size: cover;
        margin-bottom: 20px;
    }

    .text_382 {
        height: 58px;
        overflow-wrap: break-word;
        color: rgba(102, 104, 108, 1);
        font-size: 14px;
        text-align: center;
        white-space: normal;
        line-height: 20px;
        margin: 19px auto 0;
        max-width: 100%;
        padding: 0 20px;
    }


    .group_contact {

        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        max-width: 100%;
        background-color: rgba(0, 134, 131, 1);
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .group_contact_content{

    }

    .image-text_group {
        align-items: center;
    }

    .icon_call {
        width: 35px;
        height: 35px;
        margin: 4px 10px 4px 0;
    }

    .text-group_call {
        cursor: pointer;
        overflow-wrap: break-word;
        color: rgba(255, 255, 255, 1);
        font-size: 28px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 400;
        text-align: center;
        white-space: nowrap;
        line-height: 36px;
    }
    /* 调整页面的底部内边距，以避免内容被 group_contact 遮挡 */
    .page_footer {
        padding-bottom: 60px; /* 根据 group_contact 的高度调整 */
    }



    /* 响应式调整 */
    @media (max-width: 768px) {

        .links-section {
            flex-wrap: wrap;
            justify-content: center;
            max-width: 100%;
        }

        .links-column {
            width: 50%;
            margin-bottom: 25px;
            text-align: center;
            min-width: auto;
        }

        .link-header {
            margin-bottom: 10px;
        }

        .icon_call {
            width: 25px;
            height: 25px;
            margin: 4px 10px 4px 0;
        }
        .text-group_call {
            font-size: 25px;
        }

        .page_footer {
            padding-bottom: 50px; /* 调整底部内边距 */
        }

    }

    @media (max-width: 390px) {
        .group_footer {

        }
        .city-tab {
            margin-right: 20px;
        }


        .links-column {
            width: 100%;
        }

        .icon_call {
            width: 20px;
            height: 20px;
            margin: 4px 10px 4px 0;
        }
        .text-group_call {
            font-size: 22px;
        }

        .page_footer {
            padding-bottom: 50px; /* 调整底部内边距 */
        }
    }

</style>
